export default {
  title: 'Impressão de recibos',
  sections: {
    destination: 'Imprimir recibos em',
  },
  printers: {
    inner: {
      title: 'Impressora integrada',
    },
    external: {
      title: 'Impressora externa',
      width_unset: 'Largura do papel não definida',
      connect_hint: 'Ligue uma impressora para a utilizar',
      disconnect_confirm: 'Desligar esta impressora?',
      disconnect_confirm_description: 'Terá de a configurar novamente.',
      disconnect_confirm_ok: 'Sim, desligar',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Pronta',
      title: 'Pronta para imprimir',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Papel a acabar',
      title: 'O papel está quase a acabar',
      description: 'Substitua o rolo em breve. A impressão continua.',
    },
    busy: {
      label: 'Ocupada',
      title: 'Impressora ocupada',
      description: '{{name}} está a terminar outro trabalho.',
    },
    not_configured: {
      label: 'Não configurada',
      title: 'Não configurada',
      description: '{{name}} precisa de ser configurada antes de imprimir.',
    },
    offline: {
      label: 'Offline',
      title: 'Não está a imprimir',
      description: '{{name}} está offline. Os novos pedidos não estão a ser impressos.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} não está ligada.',
    },
    cover_open: {
      label: 'Tampa aberta',
      title: 'A tampa está aberta',
      description: 'Feche a tampa da impressora para retomar a impressão.',
    },
    paper_empty: {
      label: 'Sem papel',
      title: 'Sem papel',
      description: 'Substitua o rolo para retomar a impressão.',
    },
    wrong_paper: {
      label: 'Papel errado',
      title: 'Papel errado',
      description: 'O rolo carregado não corresponde à largura de papel configurada.',
    },
    cutter_error: {
      label: 'Erro de corte',
      title: 'Erro de corte',
      description: 'Verifique se há papel encravado no cortador e tente novamente.',
    },
    overheat: {
      label: 'Demasiado quente',
      title: 'Impressora demasiado quente',
      description: 'Aguarde que {{name}} arrefeça antes de imprimir novamente.',
    },
    error: {
      label: 'Erro',
      title: 'Erro na impressora',
      description: '{{name}} reportou um erro e requer atenção.',
    },
    connecting: {
      label: 'A ligar…',
      title: 'A ligar…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Não ligada',
      title: 'Não ligada',
      description: '{{name}} não está ligada.',
    },
  },
  form: {
    auto_print: {
      label: 'Imprimir novos pedidos automaticamente',
      not_ready:
        'A impressão automática está ativa, mas a impressora externa não está pronta. Os pedidos não serão impressos.',
    },
    print_copies: {
      label: 'Cópias por pedido',
      hint: 'Ative a impressão automática para definir cópias',
      decrease: 'Diminuir cópias',
      increase: 'Aumentar cópias',
    },
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar alterações',
  },
  buttons: {
    test_print: 'Impressão de teste',
    configure_external: 'Configurar',
    connect_external: 'Ligar uma impressora',
    disconnect_external: 'Desligar',
    retry_connection: 'Tentar ligar novamente',
    cancel: 'Cancelar',
  },
};
